// extracted by mini-css-extract-plugin
module.exports = {"MuiPaper-root":"datePicker_MuiPaper-root__3PUKQ","MuiPaper-elevation24":"datePicker_MuiPaper-elevation24__1xx7A"};